import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAV_ITEMS } from '../types';
import { ArrowRight, Menu, X } from 'lucide-react';

const NavBar: React.FC = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 h-20 px-6 md:px-12 flex items-center justify-between border-b border-white/5 transition-colors duration-300 ${isMobileMenuOpen ? 'bg-black' : 'bg-[#050505]/80 backdrop-blur-xl'}`}>
      
      {/* Brand */}
      <div className="flex items-center gap-12">
        <Link to="/" onClick={closeMenu} className="flex items-center gap-3 group">
            {/* Silver/Chrome Logo Accent */}
            <div className="w-4 h-4 bg-pinaka-silver transform transition-transform duration-500 group-hover:rotate-180 group-hover:scale-110 shadow-[0_0_15px_rgba(226,232,240,0.3)]"></div>
            <span className="text-xl font-bold tracking-tight text-white">PINAKA</span>
        </Link>
        
        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8">
          {NAV_ITEMS.filter(item => !['Handoff', 'Contact'].includes(item.label)).map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-sm font-medium transition-colors ${
                location.pathname === item.path ? 'text-white' : 'text-gray-400 hover:text-white'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>

      {/* Desktop CTA Section */}
      <div className="hidden md:flex items-center gap-6">
         <div className="hidden lg:flex items-center gap-2 text-[10px] text-gray-500 font-mono uppercase tracking-widest">
             <span className="w-2 h-2 bg-pinaka-silver rounded-full animate-pulse shadow-[0_0_8px_rgba(226,232,240,0.5)]"></span>
             SYSTEMS OPERATIONAL
        </div>
        
        <Link to="/contact" className="flex items-center gap-2 bg-pinaka-silver hover:bg-white text-black px-5 py-2.5 text-xs font-bold tracking-wide uppercase rounded transition-all hover:shadow-[0_0_20px_rgba(226,232,240,0.4)]">
            Start Project <ArrowRight className="w-3 h-3" />
        </Link>
      </div>

      {/* Mobile Menu Button */}
      <div className="md:hidden flex items-center">
          <button onClick={toggleMenu} aria-label="Toggle navigation menu" className="text-white p-2">
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
          <div className="fixed inset-0 top-20 bg-black z-40 flex flex-col p-8 md:hidden animate-in slide-in-from-right duration-300">
              <div className="flex flex-col gap-6">
                  {NAV_ITEMS.filter(item => item.label !== 'Handoff').map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      onClick={closeMenu}
                      className={`text-2xl font-bold transition-colors ${
                        location.pathname === item.path ? 'text-pinaka-silver' : 'text-white'
                      }`}
                    >
                      {item.label}
                    </Link>
                  ))}
                  <div className="h-px bg-white/10 my-2"></div>
                  <Link 
                    to="/contact" 
                    onClick={closeMenu}
                    className="flex items-center justify-center gap-2 bg-pinaka-silver hover:bg-white text-black px-6 py-4 text-sm font-bold tracking-wide uppercase rounded transition-all"
                  >
                    Start Project <ArrowRight className="w-4 h-4" />
                  </Link>
              </div>
          </div>
      )}

    </nav>
  );
};

export default NavBar;